import type { ReactNode } from 'react';
import type { Lens } from '@hookform/lenses';
import { z } from 'zod/v4';
import { VerticalStack } from '@interxfi/design-system/components/alignment/vertical-stack';
import { Typography } from '@interxfi/design-system/components/typography';
import { AppTextInputWithLens } from '../../../../components/form/app-text-input';

export const programInformationFormSchema = z.object({
  name: z.string().nonempty({ error: 'Name is required' }),
});

type ProgramInformationFormValues = z.infer<typeof programInformationFormSchema>;

export const defaultProgramInformationFormValues: ProgramInformationFormValues = {
  name: '',
};

interface ProgramInformationFormProps {
  lens: Lens<ProgramInformationFormValues>;
  registrationTypeField?: ReactNode;
  showTooltips?: boolean;
}

export function ProgramInformationForm({ lens, registrationTypeField, showTooltips }: ProgramInformationFormProps) {
  return (
    <VerticalStack gap={4}>
      <Typography.Level3>Program Information</Typography.Level3>

      <AppTextInputWithLens
        info={showTooltips ? 'Legal name of the company, or the DBA or trade name the company conducts business under.' : undefined}
        infoWidth={220}
        label="Name"
        lens={lens.focus('name')}
        required
      />

      {registrationTypeField}
    </VerticalStack>
  );
}
